export default __webpack_public_path__ + "static/media/pic100.7f7973be.jpg";